import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from "moment";

export default class BarGraph extends Component {
  render() {
    const { sensor, kleur, type, typesensor } = this.props;
    
    // Prepare data for ApexCharts
    function prepareApexData(sensordata) {
      if (!sensordata || !sensordata.data || !Array.isArray(sensordata.data)) return { series: [], categories: [] };

      const series = [];
      const categories = [];
      const MAX_DATA_POINTS = 1000; // Limit to prevent array overflow

      // Limit the dataset to prevent array length errors
      const dataToProcess = sensordata.data.length > MAX_DATA_POINTS
        ? sensordata.data.slice(0, MAX_DATA_POINTS)
        : sensordata.data;

      dataToProcess.forEach(function (a, key) {
        if (a.datum && a.value !== undefined && a.value !== null && key > 0) {
          const consumption = parseFloat((dataToProcess[key - 1].value - a.value).toFixed(2));
          const date = moment(a.datum).add(2, "hour");

          // Only add valid data points
          if (!isNaN(consumption) && isFinite(consumption)) {
            series.push(consumption);
            categories.push(date.valueOf()); // timestamp for ApexCharts
          }
        }
      });

      return { series, categories };
    }

    const chartData = prepareApexData(sensor || {});
    
    // ApexCharts configuration
    const options = {
      chart: {
        type: 'bar',
        height: 300,
        toolbar: {
          show: false
        },
        animations: {
          enabled: false
        },
        zoom: {
          enabled: false
        }
      },
      colors: [kleur || '#696cff'],
      plotOptions: {
        bar: {
          borderRadius: 4,
          columnWidth: '60%',
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        type: 'datetime',
        categories: chartData.categories,
        labels: {
          format: type === "maand" ? "MMM yy" : type === "uur" ? "HH:mm" : "dd MMM",
          datetimeUTC: false
        },
        title: {
          text: 'Datum'
        }
      },
      yaxis: {
        title: {
          text: 'kWh'
        },
        labels: {
          formatter: function (val) {
            return val.toFixed(2);
          }
        }
      },
      tooltip: {
        x: {
          format: type === "maand" ? "MMM yyyy" : type === "uur" ? "dd MMM HH:mm" : "dd MMM yyyy"
        },
        y: {
          formatter: function (val) {
            return val.toFixed(2) + " kWh";
          }
        }
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 3
      }
    };

    const series = [{
      name: 'Verbruik',
      data: chartData.series
    }];

    return (
      <div style={{ width: '100%', height: '300px' }}>
        {chartData.series.length > 0 ? (
          <Chart
            options={options}
            series={series}
            type="bar"
            height={300}
          />
        ) : (
          <div style={{ 
            height: '300px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#666'
          }}>
            Loading Chart...
          </div>
        )}
      </div>
    );
  }
}
